const config = {
  s3: {
    url:
      process.env.REACT_APP_S3_BUCKET_URL ||
      'https://oro-creditos.s3.amazonaws.com/'
  }
}

export default config
